// extracted by mini-css-extract-plugin
module.exports = {"tabset":"tab_tabset__c44HM","tabset-item":"tab_tabset-item__6fS_h","selected":"tab_selected__c2f_5","underline":"tab_underline__AUKDk"};